<div class="camera-access">
  <img
    src="/assets/icons/camera-access.svg"
    alt="Ícono de reconocimiento facial"
    class="camera-access__icon"
  />
  <h3 class="camera-access__title">Permite el acceso a la cámara</h3>
  <p class="camera-access__description">
    Por favor, permite el acceso a la cámara y prepárate para realizar el reconocimiento facial.<br />
    <br />
    Tu cara debe estar visible, recta y sin gafas de sol, cascos, ni gorras.
  </p>
  <div class="camera-access__button">
    <button class="btn-primary-bg" (click)="onContinue()">Comenzar</button>
  </div>
</div>
